import { Link } from "@clockwise/design-system";
import { DateTime } from "luxon";
import React from "react";
import { getRelativeDate } from "./utils/date";

type Props = {
  dateIsInPast: boolean;
  currentDurationString: string;
  onSetDate: (date: Date) => void;
  firstAvailableDate?: string | null;
};

export const NoSuggestedTimes = ({
  dateIsInPast,
  firstAvailableDate,
  onSetDate,
  currentDurationString,
}: Props) => {
  let header = <span>No Clockwise suggestions available</span>,
    subheader = "";
  if (dateIsInPast) {
    header = <span>Clockwise can't suggest times in the past</span>;
    subheader = "";
  }

  if (firstAvailableDate) {
    const date = DateTime.fromISO(firstAvailableDate);
    const formattedDate = getRelativeDate(date);
    header = (
      <span>
        First available <span className="cw-font-bold">{currentDurationString}</span> time is&nbsp;
        <Link onClick={() => onSetDate(date.toJSDate())} aria-label="Search this day">
          {formattedDate}
        </Link>
      </span>
    );
    if (dateIsInPast) {
      subheader = "Clockwise can't suggest times in the past";
    }
  } else {
    subheader = "Try broadening your search";
  }

  return (
    <div className="cw-flex cw-flex-col cw-bg-neutral cw-rounded cw-body-sm cw-p-4">
      <div className="cw-body-base cw-text-muted">{header}</div>
      {subheader && <div className="cw-caption cw-text-muted">{subheader}</div>}
    </div>
  );
};
